import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreatePlansConsultationDto, GetAllPlansConsultationDto, PlansProcedure } from '../dto/procedure.dto';

@Injectable({
  providedIn: 'root'
})
export class ProcedureService {
  private apiUrl = `${environment.api}/procedure`;

  constructor(private http: HttpClient) { }

  getPcsRelationList(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/relation`);
  }

  getListProcedures(params: { isActive: boolean, page: number }): Observable<{lista:GetAllPlansConsultationDto[], totalPage:number}>{
    const query = new HttpParams().set('active', params.isActive.toString())
                                  .set('page', params.page.toString());
    const options = {
      params: query
    };
    return this.http.get<{lista:GetAllPlansConsultationDto[], totalPage:number}>(this.apiUrl, options);
  }

  getProcedureById( planId:number, params: { isActive: boolean, page: number}): Observable<{lista:GetAllPlansConsultationDto, totalPage:number}> {
    const query = new HttpParams().set('active', params.isActive.toString())
                                  .set('page', params.page.toString());
    const options = {
      params: query
    };
    return this.http.get<{lista:GetAllPlansConsultationDto, totalPage:number}>(`${this.apiUrl}/find/${planId}`, options);

  }

  createProcedure( body: CreatePlansConsultationDto ): Observable<any> {
    return this.http.post(this.apiUrl, body);
  }

  insertSpecialty(params: {id: number, specialtyId: number[], planId: number}): Observable<any> {
    const query = new HttpParams()
                    .set('id', params.id.toString())
                    .set('specialtyId', params.specialtyId.join(','))
                    .set('planId', params.planId.toString()); 

    return this.http.post(`${this.apiUrl}/specialty`, null, { params: query });
  }

  getAllActivePlans(): Observable<PlansProcedure[]> {
    return this.http.get<PlansProcedure[]>(`${this.apiUrl}/plans`);
  }

  editPlansConsultation(pc_id: number, params: {price?:number, tAmmount?:number}): Observable<GetAllPlansConsultationDto> {
    let query = new HttpParams();
    if (params.price !== undefined){
      query = query.set('price', params.price.toString());
    }
    if (params.tAmmount !== undefined){
      query = query.set('tAmmount', params.tAmmount.toString());
    }
    return this.http.put<GetAllPlansConsultationDto>(`${this.apiUrl}/${pc_id}`, null, { params: query});
  }

  deleteSpecialtyFromPc(pc_id: number, params: { specialtyId: number } ): Observable<{status: string, message:string}> {
    const query = new HttpParams().set('spec_id', params.specialtyId.toString());
    const options = {
      params: query
    };
    return this.http.delete<{status: string, message:string}>(`${this.apiUrl}/${pc_id}`, options);
  }

  inactivateProcedure(pc_id: number): Observable<{status: string, message:string}> {
    return this.http.put<{status: string, message:string}>(`${this.apiUrl}/inactivate/${pc_id}`, null);
  }

  activateProcedure(pc_id: number): Observable<{status: string, message:string}> {
    return this.http.put<{status: string, message:string}>(`${this.apiUrl}/active/${pc_id}`, null);
  }
}
